export default "__VITE_ASSET__88Gwge7q__"